import { FroalaConfig } from "../../../config";

declare var $: any;

export class FroalaEditorOptions{
    public editorRefernce;
    public editorOptions = {};
    private key = new FroalaConfig();
    setEditorOptions(limitVal?,placeHolder?){
        return this.editorOptions = {
            key : this.key.froalaKey,
            placeholderText: placeHolder ? placeHolder : '',
            inlineMode: true,
            charCounterCount: limitVal ? true : false,
            disableRightClick: true,
            charCounterMax:limitVal ? limitVal : 2000,
            toolbarButtons: ['bold', 'italic', 'underline','paragraphStyle' , '|','html', 'paragraphFormat','fontSize','align',
                             'color','formatOL', 'formatUL','insertTable','insertHR', 'formatBlock', 'my_dropdown','fontAwesome','insertLink'],
                             events: {
                              "froalaEditor.initialized": (e, editor) => {

                                this.editorRefernce = editor;
                                if(e.target.parentElement.classList.contains('template')){
                                  editor.toolbar.show();
                                }
                                else{
                                editor.toolbar.hide();
                                }

                                if(e.target.parentElement.classList.contains( 'has-variable' )){                                  
                                  editor.events.bindClick($('body'), 'button#btn-variable', function () {
                                    if(editor.selection.get() && editor.selection.get().anchorNode && editor.selection.get().anchorNode.parentNode && 
                                    editor.selection.get().anchorNode.parentNode.parentNode && 
                                    editor.selection.get().anchorNode.parentNode.parentNode.classList &&
                                    editor.selection.get().anchorNode.parentNode.parentNode.classList.contains('fr-deletable')
                                    ){
                                      editor.selection.setAfter(editor.selection.get().anchorNode.parentNode.parentNode);
                                      editor.selection.restore();
                                    }
                                    editor.selection.save();
                                  });
                                }

                                if(e.target.parentElement.classList.contains( 'has-sms-variable' )){                                  
                                  editor.events.bindClick($('body'), 'button#btn-variable-sms', function () {
                                    if(editor.selection.get() && editor.selection.get().anchorNode && editor.selection.get().anchorNode.parentNode && 
                                    editor.selection.get().anchorNode.parentNode.parentNode && 
                                    editor.selection.get().anchorNode.parentNode.parentNode.classList &&
                                    editor.selection.get().anchorNode.parentNode.parentNode.classList.contains('fr-deletable')
                                    ){
                                      editor.selection.setAfter(editor.selection.get().anchorNode.parentNode.parentNode);
                                      editor.selection.restore();
                                    }
                                    editor.selection.save();
                                  });
                                }

                                if(e.target.parentElement.classList.contains( 'has-followUp-variable' )){                                  
                                  editor.events.bindClick($('body'), 'button#btn-variable-followUp', function () {
                                    if(editor.selection.get() && editor.selection.get().anchorNode && editor.selection.get().anchorNode.parentNode && 
                                    editor.selection.get().anchorNode.parentNode.parentNode && 
                                    editor.selection.get().anchorNode.parentNode.parentNode.classList &&
                                    editor.selection.get().anchorNode.parentNode.parentNode.classList.contains('fr-deletable')
                                    ){
                                      editor.selection.setAfter(editor.selection.get().anchorNode.parentNode.parentNode);
                                      editor.selection.restore();
                                    }
                                    editor.selection.save();
                                  });
                                }
                                
                              },
                              "froalaEditor.focus": (e, editor) => {
                                if (e.target.parentElement.classList.contains("template")) {
                                  editor.toolbar.show();
                                } else {
                                  editor.toolbar.hide();
                                }
                              },
                              "froalaEditor.blur": (e, editor) => {
                                if(e.target.parentElement.classList.contains('template')){
                                  editor.toolbar.show();
                                } else {
                                  editor.toolbar.hide();
                                }
                              },
                              "froalaEditor.commands.after": (e, editor, command) => {
                                var btnEle = document.getElementById('btn-variable');
                                // For code view command
                                if (command == 'html' && btnEle) {
                                  
                                  if (editor.codeView.isActive()) {
                                    btnEle.classList.add("disabled");
                                  }
                                  else{
                                    if(btnEle.classList.contains("disabled")){
                                      btnEle.classList.remove("disabled");
                                    }
                                  }
                                }
                              },
                              "froalaEditor.commands.before": (e, editor, command) => {
                                let range: any;
                                if (window.getSelection) {
                                  let selection = window.getSelection();
                                  if (selection.rangeCount > 0) {
                                    range = selection.getRangeAt(0);
                                    if(range.startContainer.nodeName == "#text" && range.startContainer.parentNode && range.startContainer.parentNode.classList.contains("editor-var-tag")){
                                      selection.removeAllRanges();
                                    }else{
                                      let clonedSelection = range.cloneContents();
                                      if (clonedSelection.childNodes && clonedSelection.childNodes.length > 0) {
                                        clonedSelection.childNodes.forEach((item: any) => {
                                          if (item.classList && item.classList.contains('editor-var-tag')) {
                                            selection.removeAllRanges();
                                          }
                                        });
                                      }
                                    }
                                  }
                                }
                              },
                              'froalaEditor.html.set': function (e, editor) {
                                editor.events.trigger('charCounter.update');
                              },
                            },
            fontSize: ['8', '10', '11', '12','14','16','18','20','21','24','26','28','30','32', '60', '96'],
            toolbarInline: false,
            toolbarSticky: false,
            linkAttributes:  {
              style: 'Style',
            },
            htmlExecuteScripts : false,
            enter: $.FroalaEditor.ENTER_BR,
            htmlUntouched:true,
            imageAllowedTypes: ['jpeg', 'jpg', 'png'],
            imageMove: false,
            imageTextNear: false,
            imageUploadRemoteUrls: false,
            imageInsertButtons: ['imageUpload','imageManager'],
            editorClass: 'custom-class',
            // imageUploadURL: cloudinaryConfig.cloudinaryUpload,
            imageEditButtons:['imageReplace', 'imageAlign', 'imageCaption', 'imageRemove', '|', 'imageLink', 'linkOpen', 'linkEdit', 'linkRemove', '-', 'imageDisplay', 'imageStyle', 'imageAlt', 'imageSize','alert','roundIcon'],
            imageUploadParams: {
                // upload_preset: configEnv.cloudinaryConfiguration.upload_preset
            },
            videoAllowedTypes: ['mp4', 'webm', 'ogg','avi','mov'],
            videoInsertButtons :['videoUpload'],
            videoMove: false,
            videoDefaultWidth: 400,
            // videoUploadURL: cloudinaryConfig.cloudinaryUpload,
            videoUploadParams: {
                // upload_preset: configEnv.cloudinaryConfiguration.upload_preset
            },
            colorsHEXInput: true,
            pastePlain: false,
            pluginsEnabled : ['align','colors','fontFamily','fontSize','image','imageManager','lineBreaker','link','lists','paragraphFormat','paragraphStyle','save','table','url','video','codeView','charCounter','charCounterCount','charCounterMax'],
            pasteDeniedAttrs:[]
        }
    }

    customPopupBtn(){
      $.FroalaEditor.DefineIcon('my_dropdown', {NAME: 'cog'});
      $.FroalaEditor.RegisterCommand('my_dropdown', {
        title: 'Insert Variable Field',
        focus: false,
        undo: false,
        refreshAfterCallback: false,
        callback: function () {
          let self = this;
          if(self.selection.get() && self.selection.get().anchorNode && self.selection.get().anchorNode.parentNode && 
          self.selection.get().anchorNode.parentNode.parentNode && 
          self.selection.get().anchorNode.parentNode.parentNode.classList &&
          self.selection.get().anchorNode.parentNode.parentNode.classList.contains('fr-deletable')
            ){
              self.selection.setAfter(self.selection.get().anchorNode.parentNode.parentNode);
              self.selection.restore();
          }
          self.selection.save();
          if(self.$box.length > 0 && self.$box[0].id == 'froala-editor-sms'){
            document.getElementById('btn-variable-sms').click();
          }
          else if(self.$box.length > 0 && self.$box[0].id == 'froala-editor-followUp'){
            document.getElementById('btn-variable-followUp').click();
          }
          else{
            document.getElementById('btn-variable').click();
          }
        }
      });
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/services/template-froala-options.ts